module.exports = __webpack_public_path__ + "static/img/shl_menu_logo.de1d7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_menu_logo.png
// module id = pk5d
// module chunks = 5